module.exports = __webpack_public_path__ + "static/img/standard-basemap-colorbar.a9958a9.png";